export const anomaliesConstants = {
    ANOMALIES_FETCH_REQUEST: "ANOMALIES_FETCH_REQUEST",
    ANOMALIES_FETCH_SUCCESS: "ANOMALIES_FETCH_SUCCESS",
    ANOMALIES_FETCH_FAILURE: "ANOMALIES_FETCH_FAILURE",

    ANOMALIES_COUNT_SUCCESS: "ANOMALIES_COUNT_SUCCESS",

    ANOMALIES_RESOLVE_REQUEST: "ANOMALIES_RESOLVE_REQUEST",
    ANOMALIES_RESOLVE_SUCCESS: "ANOMALIES_RESOLVE_SUCCESS",
    ANOMALIES_RESOLVE_FAILURE: "ANOMALIES_RESOLVE_FAILURE",

    ANOMALIES_CLEAR: "ANOMALIES_CLEAR",
};
